// extracted by mini-css-extract-plugin
export default {"button":"ccE2a2nW8ytt3zyZZDjeLQ==","icon":"bSghVQPWvQXD2A6XVncY9w=="};